"use strict";

exports.__esModule = true;
exports.SelectInput = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactSelect = _interopRequireWildcard(require("react-select"));
var _Icon = require("../../Elements/Icon/Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react/jsx-props-no-spreading */

/* Placeholder text prop */const Placeholder = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactSelect.components.Placeholder, {
  ...props
});

/* Generate the placeholder with image/flag placeholer */

const ImagePlaceholder = props => {
  const {
    children
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactSelect.components.Placeholder, {
    ...props,
    className: "ccl__select-input__select__placeholder--has-icon",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {}), children]
  });
};
/* Chevron arrow */
const ChevronDown = props => {
  const {
    isDisabled
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
    color: isDisabled ? 'disabled' : 'interactive',
    type: "expand-more"
  });
};
const DropdownIndicator = props => {
  const {
    isDisabled
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactSelect.components.DropdownIndicator, {
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ChevronDown, {
      isDisabled: isDisabled
    })
  });
};
DropdownIndicator.defaultProps = {
  isDisabled: false
};

/* Generate the options list with flags  */
const {
  SingleValue,
  Option
} = _reactSelect.components;
const ImageOption = props => {
  const {
    data
  } = props;
  const {
    label,
    value,
    src
  } = data;
  const OptionIcon = () => {
    if (src) return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "image-icon",
      style: {
        backgroundImage: `url(${src})`
      }
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: `fi fi-${value.toLowerCase()}`
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Option, {
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(OptionIcon, {}), label]
  });
};
/* Generate the selected value with icon  */
const ImageValue = props => {
  const {
    data
  } = props;
  const {
    label,
    value,
    src
  } = data;
  const OptionIcon = () => {
    if (src) return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "image-icon",
      style: {
        backgroundImage: `url(${src})`
      }
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: `fi fi-${value.toLowerCase()}`
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(SingleValue, {
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(OptionIcon, {}), label]
  });
};
/**
 * Primary UI component for form select fields
 */
const SelectInput = ({
  name,
  id,
  label,
  promptText,
  noOptionsMessage,
  hint,
  optionalText,
  error,
  errorMsg,
  disabled,
  isSearchable,
  srcImg,
  flagIcon,
  dataList,
  defaultValue,
  onChange,
  onBlur,
  onFocus,
  setFocus,
  ...props
}) => {
  const cssComponentClass = 'ccl__form-input';
  const cssTextClass = 'ccl__text';

  // eslint-disable-next-line no-nested-ternary
  const customComponents = flagIcon || srcImg ? {
    Placeholder: ImagePlaceholder,
    DropdownIndicator,
    Option: ImageOption,
    SingleValue: ImageValue
  } : {
    Placeholder,
    DropdownIndicator
  };
  const [value, setValue] = (0, _react.useState)(defaultValue);
  (0, _react.useEffect)(() => {
    setValue(defaultValue);
  }, [defaultValue]);
  const handleChange = v => {
    onChange(name, v.value);
  };
  const handleBlur = () => {
    onBlur(name, true);
  };
  const selectRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (setFocus) selectRef.current.focus();
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: [cssComponentClass, `${cssComponentClass}--is-form-input`, error ? `${cssComponentClass}--has-error` : '', disabled ? `${cssComponentClass}--is-disabled` : ''].join(' '),
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
      className: `${cssComponentClass}__label ${cssTextClass} ${cssTextClass}--body-text-bold`,
      htmlFor: id || name,
      children: [label, optionalText && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: `${cssComponentClass}__label__optional ${cssTextClass} ${cssTextClass}--small-body-text-italic`,
        children: `(${optionalText})`
      })]
    }), hint && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: `${cssComponentClass}__hint ${cssTextClass} ${cssTextClass}--informative-text`,
      children: hint
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactSelect.default, {
      "aria-labelledby": id || name,
      className: `ccl__select-input ccl__select-input${isSearchable ? '__combobox' : '__dropdown'}
        ${flagIcon || srcImg ? 'ccl__select-input--has-icon' : ''}
          ${error ? 'ccl__select-input__select--has-error' : ''}`,
      classNamePrefix: "ccl__select-input__select",
      components: customComponents,
      placeholder: promptText,
      isDisabled: disabled,
      isLoading: false,
      isClearable: false,
      isRtl: false,
      isSearchable: isSearchable,
      name: name,
      id: id || name,
      options: dataList,
      defaultValue: dataList.filter(option => option.value === value),
      noOptionsMessage: () => noOptionsMessage,
      onChange: handleChange,
      onBlur: handleBlur,
      onFocus: onFocus,
      ref: selectRef
    }), error && /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: `${cssComponentClass}__error-message ${cssTextClass} ${cssTextClass}--error-small-text`,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        color: "error",
        type: "error",
        size: "xs"
      }), errorMsg]
    })]
  }, value);
};
exports.SelectInput = SelectInput;
SelectInput.defaultProps = {
  id: '',
  promptText: '',
  hint: '',
  optionalText: '',
  error: false,
  errorMsg: '',
  disabled: false,
  isSearchable: false,
  flagIcon: false,
  srcImg: false,
  defaultValue: '',
  noOptionsMessage: 'No matching options',
  setFocus: false,
  onBlur: () => {},
  onChange: () => {}
};